<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ant"> </p>
<p class="FMH"><span href="#/xhtml/contents#c_ant" title="Link target outside of Sample"><span class="ePub-B-3">AUTHOR’S NOTE</span></span></p>
<p class="EPV">One thing you should know.</p>
<p class="EPV">This world—Paradise—isn’t Earth.</p>
<p class="EPV">It wasn’t Earth. It won’t ever be Earth.</p>
<p class="EPV">It is no alternate Earth.</p>
<p class="EPV">All else is possible.… </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// authorsnote.vue?3fd63ede